'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');

/**
 * ProgressIndicator
 * @param {Object} props
 * @param {string} [props.className] - 컨테이너의 추가 클래스명
 * @param {string} [props.progressClassName] - 프로그레스 바의 추가 클래스명
 * @param {number} props.value - 진행률 값 (0-100 사이의 숫자)
 */ const ProgressIndicator = ({ className, progressClassName, value })=>{
    const clampedValue = Math.min(100, Math.max(0, value));
    const progressStyle = {
        '--progress': `${clampedValue - 100}%`
    };
    return jsxRuntime.jsx("div", {
        "data-testid": "design-system-progress-indicator",
        className: tailwindMerge.twMerge('h-1 w-full overflow-hidden rounded-full', className),
        children: jsxRuntime.jsx("div", {
            className: "h-full bg-w-gray-100",
            "data-testid": "design-system-progress-indicator--background",
            children: jsxRuntime.jsx("div", {
                "data-testid": "design-system-progress-indicator--progress",
                className: tailwindMerge.twMerge('h-full translate-x-[var(--progress)] bg-primary transition-transform !duration-500', progressClassName),
                style: progressStyle
            })
        })
    });
};

module.exports = ProgressIndicator;
